// @flow
import React, { Component } from 'react';
import { View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import theme from '../../../../theme-config';
import { Icon } from '../../../../components/common';
import { getStyles } from '../../../../components/signUp/styles';

export default class DeliveryContact extends Component<Props> {
  styles = getStyles();

  render() {
    const { name, phoneNumber } = this.props.deliveryContact;
    return (
      <View style={[this.styles.container, this.props.style]}>
        <Icon name="user" color={theme.transparentIconColor} size={26} />
        <View style={this.styles.textContainer}>
          <Text style={this.styles.text}>{name}</Text>
          {phoneNumber ? <Text style={this.styles.legend}>{phoneNumber}</Text> : null}
        </View>
      </View>
    );
  }
}

type Props = {
  deliveryContact: any,
  style?: any,
};
